import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
   {
      path: '/videoManager',
      name: 'videoManager',
      component: () => import('@/components/videoManager')
    },{
      path: '/imageManager',
      name: 'imageManager',
      component: () => import('@/components/imageManager')
    },{
      path: '/systemManager',
      name: 'systemManager',
      component: () =>  import('@/components/systemManager')
    },{
      path: '/machineManager',
      name: 'machineManager',
      component: () =>  import('@/components/machineManager')
    },
  ]
})
